import Vue from "vue";
import Router from "vue-router";
import store from "../store";

import Login from "../views/Login.vue";
import AuthCallback from "../views/AuthCallback.vue";
import NotFound from "../views/NotFound.vue";
import Vehicles from "../views/Vehicles.vue";
import VehicleDetail from "../views/VehicleDetail.vue";

Vue.use(Router);

const hasToken = () => {
  return store.getters["auth/getIsLoggedIn"];
};

const ifNotAuthenticated = (to: any, from: any, next: any) => {
  if (!hasToken()) {
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to: any, from: any, next: any) => {
  if (hasToken()) {
    next();
    return;
  }
  const redirectTo = window.location.pathname;
  if (redirectTo === "/") {
    next({ name: "Login" });
  } else {
    next({ name: "Login", query: { from: redirectTo } });
  }
};

export default new Router({
  mode: "history",
  routes: [
    { path: "/", redirect: "/vehicles" },
    {
      path: "/callback",
      component: AuthCallback,
      name: "AuthCallback",
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: "/vehicles/:vin",
      component: VehicleDetail,
      name: "VehicleDetail",
      beforeEnter: ifAuthenticated,
      props: true,
    },
    {
      path: "/login",
      component: Login,
      name: "Login",
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: "/vehicles",
      component: Vehicles,
      name: "Vehicles",
      beforeEnter: ifAuthenticated,
    },
    {
      path: "*",
      component: NotFound,
      name: "NotFound",
    },
  ],
  scrollBehavior(_to, _from, _savedPosition) {
    return { x: 0, y: 0 };
  },
});
